import React from "react";

const thumbnail = (youtubeId, size) => `https://i.ytimg.com/vi_webp/${youtubeId}/${size}.webp`;

/*
*  Shows the YouTube thumbnail with a play button, and only loads the real YouTube player when it's clicked.
*  37 YouTube players on one page would make it very slow to load (the original site loaded them all up front).
*/
const EpisodeCard = ({ episode }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [thumbFailed, setThumbFailed] = React.useState(false);
  const label = `Episode ${episode.number}: ${episode.title}`;

  return (
    <article className={"episode"}>
      <div className={"episode-video"}>
        {isPlaying ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${episode.youtubeId}?autoplay=1&rel=0`}
            title={label}
            allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"}
            referrerPolicy={"strict-origin-when-cross-origin"}
            allowFullScreen={true}
          />
        ) : (
          <button
            type={"button"}
            className={"episode-play"}
            onClick={() => setIsPlaying(true)}
            aria-label={`Play ${label}`}
          >
            {thumbFailed ? (
              //Very new or low resolution uploads don't have the HD thumbnail yet - this one always exists (with black bars, cropped off by CSS)
              <img
                src={`https://i.ytimg.com/vi/${episode.youtubeId}/hqdefault.jpg`}
                alt={""}
                width={"480"}
                height={"360"}
                loading={"lazy"}
              />
            ) : (
              <img
                src={thumbnail(episode.youtubeId, "maxresdefault")}
                srcSet={`${thumbnail(episode.youtubeId, "mqdefault")} 320w, ${thumbnail(episode.youtubeId, "maxresdefault")} 1280w`}
                sizes={"(max-width: 599px) 100vw, (max-width: 999px) 50vw, 400px"}
                alt={""}
                width={"1280"}
                height={"720"}
                loading={"lazy"}
                onError={() => setThumbFailed(true)}
              />
            )}
            <svg
              className={"episode-play-icon"}
              viewBox={"0 0 68 48"}
              aria-hidden={"true"}
              focusable={"false"}
            >
              <path
                className={"episode-play-icon-bg"}
                d={"M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"}
              />
              <path
                d={"M45 24 27 14v20"}
                fill={"#fff"}
              />
            </svg>
          </button>
        )}
      </div>
      <h3 className={"episode-title"}>{label}</h3>
      <p className={"episode-description"}>{episode.description}</p>
    </article>
  );
};

export default EpisodeCard;
